import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

export default function ApplyThanksPage() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex items-center justify-center px-4" data-testid="apply-thanks-page">
      <div className="animate-fade-up glass-card rounded-2xl p-8 sm:p-12 max-w-md w-full text-center">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#10B981]/20 flex items-center justify-center mb-6">
          <CheckCircle className="w-10 h-10 text-[#10B981]" />
        </div>
        <h2 className="font-outfit font-extrabold text-3xl text-white mb-3">Danke!</h2>
        <p className="text-[#9CA3AF] text-lg mb-8">Wir melden uns bei dir.</p>
        <Button onClick={() => navigate('/')} className="bg-[#3B82F6] hover:bg-[#2563EB] text-white font-outfit font-bold rounded-xl h-12 px-8" data-testid="back-home-btn">
          Zurück zur Startseite
        </Button>
      </div>
    </div>
  );
}
